module.exports = "<div class=\"picture-group\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baPictureUploader/baPictureUploader.html
// module id = ../../../../../src/app/theme/components/baPictureUploader/baPictureUploader.html
// module chunks = main